<template>
  <div>
    <Loading :center="false" v-if="loading" />
    <div v-else>
      <ScrollBar :minHeight="200" :maxHeight="360">

        <div v-if="groupedPatrimonies.length" class="patrimony-list">
          <div
            v-for="item in groupedPatrimonies"
            :key="item.barCode"
            class="patrimony-card"
            :class="item.isFinished ? 'card-finished' : 'card-pending'"
          >
            <div class="card-row">

              <div class="barcode-cell">
                <Tooltip v-if="item.barCode && item.barCode.length > 8" :title="item.barCode">
                  <span class="barcode-text barcode-truncated title">{{ item.barCode }}</span>
                </Tooltip>
                <span v-else class="barcode-text">{{ item.barCode }}</span>
              </div>

              <div class="mov-area">
                <div class="mov-block" v-if="item.hasRented">
                  <span class="badge badge-rent">Locado</span>
                  <span class="mov-date">
                    <i class="fa-regular fa-clock"></i>
                    {{ formatDate(item.rentedAt) }}
                  </span>
                </div>

                <i class="fa-solid fa-arrow-right sep-arrow" v-if="item.hasRented"></i>

                <div class="mov-block" v-if="item.hasReturned">
                  <span class="badge badge-returned">Retornado</span>
                  <span class="mov-date">
                    <i class="fa-regular fa-clock"></i>
                    {{ formatDate(item.returnedAt) }}
                  </span>
                </div>

                <div class="mov-block" v-if="item.hasRented && !item.hasReturned">
                  <span class="waiting-label">
                    <i class="fa-regular fa-hourglass-half"></i>
                    Aguardando retorno
                  </span>
                </div>
              </div>

              <span
                class="status-pill"
                :class="item.isFinished ? 'status-finished' : 'status-pending'"
                :title="item.isFinished ? 'Finalizado' : 'Retorno pendente'"
              >
                <i :class="item.isFinished ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle-exclamation'"></i>
                {{ item.isFinished ? 'Finalizado' : 'Pendente' }}
              </span>

            </div>
          </div>
        </div>

        <div v-else class="empty-state">
          <i class="fa-regular fa-box-open empty-icon"></i>
          <span>Nenhum patrimônio encontrado</span>
        </div>

      </ScrollBar>
    </div>
  </div>
</template>
<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Tooltip from "@nixweb/nixloc-ui/src/component/layout/Tooltip";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "PatrimonyMoviment",
  components: {
    Loading,
    ScrollBar,
    Tooltip,
  },
  data() {
    return {
      urlGet: "/api/v1/stock/patrimony-moviment/get-all-by-item",
      item: {},
      content: {
        data: [],
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
    groupedPatrimonies() {
      const grouped = {};

      this.movements.forEach((movement) => {
        const code = movement.barCode || "-";

        if (!grouped[code]) {
          grouped[code] = {
            barCode: code,
            hasRented: false,
            hasReturned: false,
            rentedAt: null,
            returnedAt: null,
          };
        }

        if (movement.status === 1) {
          grouped[code].hasRented = true;
          grouped[code].rentedAt = this.pickLatestDate(
            grouped[code].rentedAt,
            movement.registeredDate
          );
        }

        if (movement.status === 2) {
          grouped[code].hasReturned = true;
          grouped[code].returnedAt = this.pickLatestDate(
            grouped[code].returnedAt,
            movement.registeredDate
          );
        }
      });

      return Object.values(grouped)
        .map((item) => ({
          ...item,
          isFinished: item.hasRented && item.hasReturned,
        }))
        .sort((a, b) => a.barCode.localeCompare(b.barCode));
    },
    movements() {
      return Array.isArray(this.content.data) ? this.content.data : [];
    },
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    getAll() {
      const params = {
        url: this.urlGet,
        obj: {
          itemsRentId: this.item.id,
        },
      };

      this.getApi(params).then((response) => {
        this.content = response && response.content ? response.content : { data: [] };

        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
    pickLatestDate(currentDate, newDate) {
      if (!newDate) {
        return currentDate;
      }

      if (!currentDate) {
        return newDate;
      }

      return new Date(newDate) > new Date(currentDate) ? newDate : currentDate;
    },
    formatDate(date) {
      if (!date) {
        return "-";
      }

      const parsedDate = new Date(date);

      if (Number.isNaN(parsedDate.getTime())) {
        return "-";
      }

      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(parsedDate);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "totalizationAndHistory") {
          this.loading = true;
          this.item = event.data;
          this.getAll();
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style scoped>
.patrimony-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px;
}

.patrimony-card {
  border-radius: 8px;
  border: 1px solid #e5e8ef;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.15s ease;
}

.patrimony-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.07);
}

.card-finished { border-left: 4px solid #b8860b; }
.card-pending  { border-left: 4px solid #FAAD15; }

.card-row {
  display: grid;
  grid-template-columns: 90px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
}

.barcode-cell {
  width: 90px;
  flex-shrink: 0;
}

.barcode-text {
  display: block;
  color: #3d4a5c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.barcode-truncated {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.mov-area {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

.mov-block {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex-shrink: 0;
}

.badge {
  font-size: 11px !important;
  border-radius: 10px !important;
  padding: 3px 9px;
  color: white;
  font-weight: 600;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.badge-rent     { background-color: #00008b; }
.badge-returned { background-color: #b8860b; }

.mov-date {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #8a94a6;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.sep-arrow {
  color: #d0d5dd;
  font-size: 10px;
}

.waiting-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #adb5bd;
  font-size: 11px;
  font-style: italic;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  padding: 3px 10px;
  margin-left: auto;
  white-space: nowrap;
}

.status-finished {
  color: #fff;
  background: #b8860b;
}

.status-pending {
  color: #a07500;
  background: #fff8e1;
}

.status-pending i { color: #FAAD15; }

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 0;
  color: #adb5bd;
  gap: 10px;
}

.empty-icon {
  font-size: 32px;
}
</style>